import CoreNumericInputComponent from './CoreNumericInputComponent';

const CorePercentageInputComponent = (props) => <CoreNumericInputComponent {...props} />;

CorePercentageInputComponent.props = {
  ...CoreNumericInputComponent.props,
}

CorePercentageInputComponent.defaultProps = {
  ...CoreNumericInputComponent.defaultProps,
  postfix: ' %',
  alwaysDecimals: true,
  decimals: 2,
};

export default CorePercentageInputComponent;
